import type { GameState } from '../sim/types';

/*
 * המחזיק של מצב המשחק.
 *
 * מחלקה רגילה ולא state של React, בכוונה: המצב מתחלף 20 פעמים בשנייה, והרנדרר
 * קורא ממנו 60 פעמים בשנייה. React נרשם **רק למונה הגרסה** דרך useSyncExternalStore,
 * כך שהוא משווה מספר ולא זהות אובייקט, מתעורר פעם אחת לפריים, והרכיבים קוראים
 * `store.cur` ישירות.
 *
 * `prev` נשמר כדי שהקנבס יוכל לשזור בין שני טיקים ולתת תנועה חלקה ב-60fps מעל
 * סימולציה של 20Hz.
 */
export class GameStore {
    private state: GameState;
    private previous: GameState;
    private counter = 0;
    private readonly listeners = new Set<() => void>();

    constructor(initial: GameState) {
        this.state = initial;
        this.previous = initial;
    }

    get cur(): GameState {
        return this.state;
    }

    get prev(): GameState {
        return this.previous;
    }

    get version(): number {
        return this.counter;
    }

    commit(next: GameState): void {
        this.previous = this.state;
        this.state = next;
        this.counter++;
    }

    /** החלפת מצב בלי היסטוריה — לטעינת שמירה, שם אין "טיק קודם" לשזור אליו. */
    reset(next: GameState): void {
        this.previous = next;
        this.state = next;
        this.counter++;
    }

    notify(): void {
        for (const listener of this.listeners) listener();
    }

    subscribe = (listener: () => void): (() => void) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };

    getVersion = (): number => this.counter;
}
